export default "__VITE_ASSET__DIEYSxgW__"